import { type Achievement } from '../../data/local/achievements';

interface AchievementBadgeProps {
  achievement: Achievement;
  size?: 'sm' | 'md' | 'lg';
  showDetails?: boolean;
}

const sizeClasses = {
  sm: 'w-12 h-12 text-lg',
  md: 'w-16 h-16 text-2xl',
  lg: 'w-24 h-24 text-4xl',
};

export function AchievementBadge({
  achievement,
  size = 'md',
  showDetails = false,
}: AchievementBadgeProps) {
  const earnedClass = achievement.earned
    ? 'bg-gradient-to-br from-amber-100 to-amber-200 border-amber-300'
    : 'bg-slate-100 border-slate-300 opacity-50 grayscale';

  return (
    <div className="flex flex-col items-center gap-1">
      <div
        className={`rounded-xl border-2 flex items-center justify-center font-bold shadow-sm transition-transform hover:scale-105 ${sizeClasses[size]} ${earnedClass}`}
        title={
          achievement.earned
            ? `已解锁: ${achievement.description}`
            : `未解锁: ${achievement.description}`
        }
      >
        {achievement.icon}
      </div>
      {showDetails && (
        <>
          <span
            className={`text-sm font-semibold text-center ${achievement.earned ? 'text-slate-800' : 'text-slate-400'}`}
          >
            {achievement.name}
          </span>
          <span className="text-xs text-slate-400 text-center max-w-[100px]">
            {achievement.description}
          </span>
          {achievement.earnedAt && (
            <span className="text-xs text-amber-600">
              {new Date(achievement.earnedAt).toLocaleDateString('zh-CN')}
            </span>
          )}
        </>
      )}
    </div>
  );
}
